var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"flex flex-wrap min-h-screen"},[_c('div',{staticClass:"px-4",class:{ 
        'w-7/12': _vm.isShowSidebar, 
        'w-full': !_vm.isShowSidebar
      }},[_c('BigTitle',{staticClass:"mb-11 pt-40",attrs:{"title":"Settings"}}),_c('Labels',{on:{"addNewLabel":function($event){return _vm.setAddNewLabelVisibility(true)}}})],1),_c('div',{staticClass:"px-8 pt-44 z-10 base-bg-darker",class:{ 
        'w-5/12': _vm.isShowSidebar, 
        'hidden': !_vm.isShowSidebar
      }},[(_vm.isShowSidebar)?_c('AddNewLabel',{on:{"close":function($event){return _vm.setAddNewLabelVisibility(false)}}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }